import React, { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { commonServices } from "../../../../api/services/commonServices";
import {
  setLeaveCalendarData,
  setLeaveCalendarLoader,
} from "../../../../infra/aggregates/myProfile/leavesAggregates/leaveCalendarSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import DTOLeaveCalendarData from "./DTOLeaveCalendarData";
import LeaveCalendarDataPresenter from "./LeaveCalendarDataPresenter";

const LeaveCalendarDataController = () => {
  const { t } = useTranslation();
  const [leaveCalendar, setLeaveCalendar] = useState([]);

  const selector = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const getLeaveCalendarData = (leaveData) => {
    setLeaveCalendar(leaveData);
  };

  const callbackSubmit = (month, year) => {
    dispatch(setLeaveCalendarLoader(true));

    const _currentMonth = month + 1;
    commonServices
      .getCalendarData(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        _currentMonth,
        year
      )
      .then((response) => {
        if (response?.data?.leaves?.length > 0) {
          dispatch(setLeaveCalendarData(response?.data?.leaves));
          setLeaveCalendar(response?.data?.leaves);
          dispatch(setLeaveCalendarLoader(false));
        } else {
          dispatch(setLeaveCalendarLoader(false));
          toast.error(t("No more leaves!"));
        }
      })
      .catch((err) => {
        dispatch(setLeaveCalendarLoader(false));
        console.log(err);
      });
  };

  return (
    <div>
      <DTOLeaveCalendarData setAllLeaveCalendarData={getLeaveCalendarData} />
      <LeaveCalendarDataPresenter
        leaveData={leaveCalendar}
        handleCalendarChange={callbackSubmit}
      />
    </div>
  );
};

export default LeaveCalendarDataController;
